import { environment } from "@env/environment";

export const getPdfUrl = (url: string, filename: string = "document.pdf") => {
  return `${environment.API_INVOICING_PUBLIC}/download-pdf?uri=${url}&filename=${filename}`;
};

export const getAriaTicketUrl = (
  tenantId: string,
  orderId: string,
  orderType: string,
): string => {
  const result = `${environment.BASE_ARIA}/new-ticket/INCIDENCE/${tenantId}/${orderId}/${orderType}/`;

  console.log("url", result);
  return result;
};
